import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Container, Responsive, Image } from "semantic-ui-react";
import API from "../API/API";
import { bannercancun, dreamlagoonsLogoAra } from "../assets/Assets";
import { GetContent } from "../scripts";
import Comptitle from "./Comptitle";

class HeaderComp extends React.Component {
  constructor(props) {
    super(props);
  }

  renderInDesktop() {
    return (
      <Container>
        <div
          id="firstContainer"
          style={{
            backgroundImage: "url(" + this.props.headerImg + ")",
            backgroundColor: "#868686"
          }}
          className="headerImage"
        />

        <div
          style={{
            width: "210px",
            height: "10rem",
            backgroundColor: "white",
            zIndex: "666",
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            justifyContent: "center",
            borderRadius: "0px 0px 4px 4px"
          }}
          id="nav"
        >
          <Image
            src={this.props.logo}
            height="110"
            width="158"
            textAlign="center"
            style={{
              display: "flex",
              justifyContent: "center",
              alignSelf: "center"
            }}
          />
        </div>
        <Container
          id="asdhasd"
          style={{
            height: "82.2vh",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              width: "100%"
            }}
          >
            <div
              style={{
                justifyContent: "center",
                width: "80%",
                textAlign: "center",
                color: "white",
                marginTop: "20vh"
              }}
            >
              <Comptitle
                simple
                textShadow
                title="Dream Lagoons"
                body={this.props.title}
                bold
                titlesize="6rem"
                titlebold
                bodysize="3rem"
                marginSubtitle="0px"
                marginTitle="5px"
              />
            </div>
          </div>
        </Container>
      </Container>
    );
  }

  renderInTablet() {
    return (
      <Container>
        <div
          id="firstContainer"
          style={{
            backgroundImage: "url(" + this.props.headerImg + ")",
            backgroundColor: "#868686"
          }}
          className="headerImage"
        />

        <div
          style={{
            width: "210px",
            height: "10rem",
            backgroundColor: "white",
            zIndex: "666",
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            justifyContent: "center",
            borderRadius: "0px 0px 4px 4px"
          }}
          id="nav"
        >
          <Image
            src={this.props.logo}
            height="110"
            width="158"
            textAlign="center"
            style={{
              display: "flex",
              justifyContent: "center",
              alignSelf: "center"
            }}
          />
        </div>
        <Container
          id="asdhasd"
          style={{
            height: "23rem",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              width: "100%"
            }}
          >
            <div
              style={{
                justifyContent: "center",
                width: "80%",
                textAlign: "center",
                color: "white",
                marginTop: "15vh"
              }}
            >
              <Comptitle
                simple
                textShadow
                title="Dream Lagoons"
                body={this.props.title}
                bold
                titlesize="3rem"
                titlebold
                bodysize="2rem"
                marginSubtitle="0px"
                marginTitle="5px"
              />
            </div>
          </div>
        </Container>
      </Container>
    );
  }

  renderInMobile() {
    return (
      <Container>
        <div
          id="firstContainer"
          style={{
            backgroundImage: "url(" + this.props.headerImg + ")",
            backgroundColor: "#868686"
          }}
          className="headerImage"
        />

        <div
          style={{
            width: "180px",
            height: "8.5rem",
            backgroundColor: "white",
            zIndex: "666",
            marginLeft: "auto",
            marginRight: "auto",
            display: "flex",
            justifyContent: "center",
            borderRadius: "0px 0px 4px 4px"
          }}
          id="nav"
        >
          <Image
            src={this.props.logo}
            height="100"
            width="148"
            textAlign="center"
            style={{
              display: "flex",
              justifyContent: "center",
              alignSelf: "center"
            }}
          />
        </div>
        <Container
          id="asdhasd"
          style={{
            height: "20rem",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              width: "100%"
            }}
          >
            <div
              style={{
                justifyContent: "center",
                alignSelf: "center",
                padding: "0rem",
                textAlign: "center",
                color: "white"
              }}
            >
              <Comptitle
                simple
                textShadow
                title="Dream Lagoons"
                body={this.props.title}
                bold
                titlesize="2.5rem"
                titlebold
                bodysize="2rem"
                marginSubtitle="0px"
                marginTitle="5px"
              />
            </div>
          </div>
        </Container>
      </Container>
    );
  }

  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}

const mapStateToProps = ({ data }) => {
  const { pages, currentlanguage } = data;
  return {
    pages,
    currentlanguage
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(HeaderComp)
);
